import { BridgeUser } from "../_models/BridgeUser";

export class BridgeUserMapper {
    static fromEverouUser(everouUser) {
        return BridgeUser(everouUser);
    }
}